module.exports = __webpack_public_path__ + "img/ordMatrixyl3.c580fe96.jpg";